import React from 'react';
import styled from 'styled-components';
import NumberFormat from 'react-number-format';
import { useFormikContext } from 'formik';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import { TPostAdInitialValues } from 'src/Types';
import Input from 'src/components/Common/formik/input/TextField';

interface IStyledProps {
  isActive?: boolean;
  loading?: boolean;
  selected?: boolean;
}
const ListingSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;
const TitleWrapper = styled.div`
  margin: 24px 0 12px;
`;
const Title = styled.h1`
  font-size: 25px;
  line-height: 40px;
  font-weight: 700;
  margin: 0;
  color: ${({ theme }) => theme.colors.secondary};
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
`;
const RowContainer = styled.div`
  display: block;
  //flex-direction: row;
  margin-top: 10px;
  //align-items: center;
`;
const StyledButton = styled(Button)<IStyledProps>`
  background-color: ${({ selected }) => (selected && 'rgb(44, 128, 70) !important') || 'inherit'};
`;
const StyledInput = styled(Input)`
  margin: 0 !important;
  width: 100%;
`;
const StyledNumberFormat = styled(NumberFormat)`
  margin-top: 10px !important;
  width: 100%;
`;
const ButtonGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
const Label = styled.label`
  margin: 10px 0;
`;

type Props = {
  isWantedAd?: boolean;
};
const RentalPrices: React.FC<Props> = ({ isWantedAd }) => {
  const { values, touched, errors, setFieldValue, setFieldTouched } = useFormikContext<
    TPostAdInitialValues
  >();
  const onPriceChangeHandler = (val: any) => {
    const { value } = val;
    const parsedVal = parseInt(value, 10);
    setFieldValue('expectedPrice', parsedVal || '');
  };
  const onRentValueChangeHandler = (val: any) => {
    const { value } = val;
    const parsedVal = parseInt(value, 10);
    setFieldValue('rentValue', parsedVal || '');
  };
  return (
    <ListingSection>
      <TitleWrapper>
        <Title>Set Rental Prices</Title>
      </TitleWrapper>
      <Container>
        <RowContainer>
          <StyledNumberFormat
            allowNegative={false}
            thousandSeparator
            name="expectedPrice"
            value={values.expectedPrice}
            variant="outlined"
            onBlur={() => {
              setFieldTouched('expectedPrice', true);
            }}
            placeholder="Enter Expected price of item"
            customInput={TextField}
            label="Expected price"
            InputLabelProps={{ shrink: true }}
            error={(errors.expectedPrice && touched.expectedPrice) || false}
            helperText={(touched.expectedPrice && errors.expectedPrice) || ' '}
            onValueChange={onPriceChangeHandler}
            InputProps={{
              startAdornment: <InputAdornment position="start">PKR</InputAdornment>,
            }}
          />
          <StyledNumberFormat
            allowNegative={false}
            thousandSeparator
            name="rentValue"
            variant="outlined"
            value={values.rentValue}
            onBlur={() => {
              setFieldTouched('rentValue', true);
            }}
            placeholder="Enter rent value"
            customInput={TextField}
            label="Rent value"
            InputLabelProps={{ shrink: true }}
            error={(errors.rentValue && touched.rentValue) || false}
            helperText={(touched.rentValue && errors.rentValue) || ' '}
            onValueChange={onRentValueChangeHandler}
            InputProps={{
              startAdornment: <InputAdornment position="start">PKR</InputAdornment>,
            }}
          />
        </RowContainer>
        {isWantedAd && (
          <RowContainer>
            <StyledInput
              name="rentPeriod"
              label="Rent Period*"
              placeholder="Enter Rent period"
              value={values.rentPeriod}
              onBlurHandler={() => setFieldTouched('rentPeriod', true)}
              onChangeHandler={(val) => setFieldValue('rentPeriod', val)}
              margin="normal"
              outlined
              error={(errors?.rentPeriod && touched.rentPeriod) || false}
              errorText={(touched.rentPeriod && errors.rentPeriod) || ''}
            />
          </RowContainer>
        )}
        {!isWantedAd && (
          <RowContainer>
            <ButtonGroupContainer>
              <Label>Price negotiable</Label>
              <ButtonGroup
                color="primary"
                aria-label="large outlined primary button group"
                variant="contained"
                size="medium"
                disableElevation
              >
                <StyledButton
                  selected={!values.isNegotiable}
                  onClick={() => setFieldValue('isNegotiable', false)}
                >
                  Fixed
                </StyledButton>
                <StyledButton
                  selected={values.isNegotiable}
                  onClick={() => setFieldValue('isNegotiable', true)}
                >
                  Negotiable
                </StyledButton>
              </ButtonGroup>
            </ButtonGroupContainer>
            <ButtonGroupContainer>
              <Label>Rent per</Label>
              <ButtonGroup
                color="primary"
                aria-label="large outlined primary button group"
                variant="contained"
                size="medium"
                disableElevation
              >
                <StyledButton
                  selected={values.rentPer === 'day'}
                  onClick={() => setFieldValue('rentPer', 'day')}
                >
                  Day
                </StyledButton>
                <StyledButton
                  selected={values.rentPer === 'month'}
                  onClick={() => setFieldValue('rentPer', 'month')}
                >
                  Month
                </StyledButton>
              </ButtonGroup>
            </ButtonGroupContainer>
          </RowContainer>
        )}
      </Container>
    </ListingSection>
  );
};

export default RentalPrices;
